import { memo } from "react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { formatRelativeTime } from "@/core/utils/date";
import { cn } from "@/core/utils/utils";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { IMostRecentTextMessage } from "@/text-messages/text-messages";

interface TextMessageListItemProps {
  textMessage: IMostRecentTextMessage;
  onSelect: (textMessage: IMostRecentTextMessage) => void;
  isSelected: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const TextMessageListItem = memo(
  ({
    textMessage,
    onSelect,
    isSelected,
    onMouseEnter,
    onMouseLeave,
  }: TextMessageListItemProps) => (
    <Stack
      gap="xs"
      className={cn(
        "cursor-pointer border-b border-stroke-tertiary py-4 last:border-b-0 hover:bg-blue-5",
        { "bg-blue-5": isSelected },
      )}
      fullWidth
      onClick={() => onSelect(textMessage)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Stack
        direction="row"
        justify="start"
        align="baseline"
        fullWidth
        className="pb-1"
      >
        <Typography variant="subtitleW2">
          {getCustomerNameOrPhone(textMessage.customer)}
        </Typography>
        <Typography variant="bodyW2" textColor="secondary">
          {formatRelativeTime(textMessage.created_at)}
        </Typography>
      </Stack>
      <Typography variant="bodyW1" className="max-w-[800px]">
        {textMessage.body ||
          `${textMessage.media_urls.length} attachment${textMessage.media_urls.length > 1 ? "s" : ""}`}
      </Typography>
    </Stack>
  ),
);
